import type { FC, SVGProps } from 'react'

export const LowPass: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9272 10.1541C16.6763 8.9177 14.8411 8.25 12.5 8.25H5C4.58579 8.25 4.25 8.58579 4.25 9C4.25 9.41421 4.58579 9.75 5 9.75H12.5C14.5589 9.75 15.9737 10.3323 16.8728 11.2209C17.7723 12.11 18.25 13.3989 18.25 15C18.25 15.4142 18.5858 15.75 19 15.75C19.4142 15.75 19.75 15.4142 19.75 15C19.75 13.1011 19.1777 11.39 17.9272 10.1541Z"
      fill="currentColor"
    />
  </svg>
)
